import { createFileRoute } from '@tanstack/react-router';
import Event from 'src/pages/Event';

export const Route = createFileRoute('/$organizationSlug/events/')({
  component: Event,
});
